/**
 * ProductGroupsProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import StoredValueTransactionsContext from './stored-value-transactions-context'
import { fetchStoredValueTransactions } from './stored-value-transactions-api'

export default function StoredValueTransactionsProvider({ children }) {
  const state = {
    fetchStoredValueTransactions,
  }
  return (
    <StoredValueTransactionsContext.Provider value={state}>
      {children}
    </StoredValueTransactionsContext.Provider>
  )
}
